import {RestService} from "@/services/rest/RestService";
import {AxiosResponse} from "axios";
import {ImageSelectionSettingsAPIApi} from "@/api/pharma-photo-product-image";
import {
    ProductImageSelectionOverviewResultsRestDto,
    ProductImageSelectionSettingsRestDto
} from "@/api/pharma-photo-product-image/models";

export class ImageSelectionSettingsRestService extends RestService {

    private api: ImageSelectionSettingsAPIApi;

    protected constructor() {
        super();

        this.api = new ImageSelectionSettingsAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().photoUrl);
    }

    public async findProductImageSelectionSettings(
        productCode: string
    ): Promise<ProductImageSelectionOverviewResultsRestDto> {
        const response: AxiosResponse<ProductImageSelectionOverviewResultsRestDto> =
            await this.api.findProductImageSelectionSettings(productCode);

        return response.data;
    }

    public async syncProductImageSelectionSettings(
        productCode: string,
        body?: ProductImageSelectionSettingsRestDto|null
    ): Promise<void> {
        await this.api.syncProductImageSelectionSettings(productCode, body);
    }
}
